package ui.app.assign.detail.definition

import androidx.compose.foundation.layout.*
import androidx.compose.material3.HorizontalDivider
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import apps.App
import compose.assets.Svg
import compose.assets.svg.*
import ssoft.frontend.generated.resources.*
import ui.app.assign.detail.AppDetailScope
import ui.widget.Space

@Composable
fun AppDetailScope.AppDefOfUsbPlayer(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfUsbPlayer
) {
    if (display.isMobileOrSmall) {
        Column {
            DefaultFields(
                nnvl = wrapper,
                modifier = Modifier.fillMaxWidth(),
                secondaryContent = {
                    Column(
                        modifier = Modifier.fillMaxWidth(),
                        verticalArrangement = Arrangement.spacedBy(16.dp)
                    ) {
                        Items(wrapper, nnvl)
                    }
                    Space(16.dp)
                })
        }
    } else {
        Row {
            Column(Modifier.weight(1F)) {
                DefaultFields(
                    nnvl = wrapper,
                    modifier = Modifier.fillMaxWidth()
                )
            }
            Space(16.dp)

            Column(
                modifier = Modifier.weight(1F),
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                Items(wrapper, nnvl)
            }
        }
    }
    Space(64.dp)
}

@Composable
private fun AppDetailScope.Items(wrapper: AppDetailScope.Wrapper, nnvl: AppDetailScope.WrapperDefinition.OfUsbPlayer) {
    MediaTypes(wrapper, nnvl)
    SortMode(wrapper, nnvl)
    ScaleMode(wrapper, nnvl)
    PreviewTools(wrapper, nnvl)
}

@Composable
private fun AppDetailScope.ScaleMode(wrapper: AppDetailScope.Wrapper, nnvl: AppDetailScope.WrapperDefinition.OfUsbPlayer) {
    DropDownField(
        icon = Svg.Fit_to_screen_outline,
        field = nnvl.scaleAs,
        label = Res.string.layer_bottom_detail__usb_player_media_scale_label,
        variants = mapOf(
            App.UsbPlayer.Scale.FILL.mask to Res.string.layer_bottom_detail__usb_player_media_scale_fit,
            App.UsbPlayer.Scale.CENTER.mask to Res.string.layer_bottom_detail__usb_player_media_scale_center,
            App.UsbPlayer.Scale.CROP.mask to Res.string.layer_bottom_detail__usb_player_media_scale_crop
        ),
        modifier = Modifier.fillMaxWidth(),
        canEdit = wrapper.canEdit
    )
}

@Composable
private fun AppDetailScope.SortMode(wrapper: AppDetailScope.Wrapper, nnvl: AppDetailScope.WrapperDefinition.OfUsbPlayer) {
    DropDownField(
        icon = Svg.Sort,
        field = nnvl.sortBy,
        label = Res.string.layer_bottom_detail__usb_player_sort_by_label,
        variants = mapOf(
            App.UsbPlayer.Sort.NAME_ASC.mask to Res.string.layer_bottom_detail__usb_player_sort_by_name_asc,
            App.UsbPlayer.Sort.NAME_DESC.mask to Res.string.layer_bottom_detail__usb_player_sort_by_name_desc,
            App.UsbPlayer.Sort.DATE_ASC.mask to Res.string.layer_bottom_detail__usb_player_sort_by_date_asc,
            App.UsbPlayer.Sort.DATE_DESC.mask to Res.string.layer_bottom_detail__usb_player_sort_by_date_desc
        ),
        modifier = Modifier.fillMaxWidth(),
        canEdit = wrapper.canEdit
    )
}

@Composable
private fun AppDetailScope.MediaTypes(wrapper: AppDetailScope.Wrapper, nnvl: AppDetailScope.WrapperDefinition.OfUsbPlayer) {
    CheckboxGroup(
        Res.string.layer_bottom_detail__usb_player_media_type_label,
        modifier = Modifier.fillMaxWidth()
    ) {
        CheckboxRow(
            wrapper = wrapper,
            field = nnvl.showImage,
            icon = Svg.Image,
            label = Res.string.layer_bottom_detail__usb_player_media_type_image
        )
        HorizontalDivider(Modifier.padding(horizontal = 16.dp))
        CheckboxRow(
            wrapper = wrapper,
            icon = Svg.Video,
            field = nnvl.showVideo,
            label = Res.string.layer_bottom_detail__usb_player_media_type_video
        )
    }
}

@Composable
private fun AppDetailScope.PreviewTools(wrapper: AppDetailScope.Wrapper, nnvl: AppDetailScope.WrapperDefinition.OfUsbPlayer) {
    CheckboxGroup(
        Res.string.layer_bottom_detail__usb_player_preview_label,
        modifier = Modifier.fillMaxWidth()
    ) {
        CheckboxRow(
            wrapper = wrapper,
            field = nnvl.autoContinue,
            icon = Svg.Video,
            label = Res.string.layer_bottom_detail__usb_player_preview_auto_continue
        )
        HorizontalDivider(Modifier.padding(horizontal = 16.dp))
        CheckboxRow(
            wrapper = wrapper,
            icon = Svg.Tag_text,
            field = nnvl.showMediaName,
            label = Res.string.layer_bottom_detail__usb_player_preview_show_media_name
        )
    }
}